(function () {
  'use strict';

  angular.module('wsLrs.services').
  /**
   * A service that wraps TinCanJS's tincan object, which automatically
   * configures the endpoint based on the current user.
   */
  factory("TinCanJS", ['$q', '$sanitize', 'User', 'Api', 'Utils', 'wsConstants', 'xsrf', function ($q, $sanitize, User, Api, Utils, wsConstants, xsrf) {
    function truncateString(str, length) {
      if (!str || str.length < 4 || str.length <= length) {
        return str;
      }
      return str.substr(0, length - 3) + '...';
    }
    function getResponseText(targetObject, result) {
      var response,
        objDef,
        componentName = null,
        components,
        responses,
        responseStr = [],
        first = true,
        responseId,
        i,
        j,
        source,
        target,
        responseParts;
      if (!result || !result.response) {
        return "";
      }
      response = result.response;
      if (!targetObject || targetObject.objectType !== "Activity" || !targetObject.definition || !targetObject.definition.interactionType) {
        return $sanitize(response);
      }
      objDef = targetObject.definition;

      // TODO: move the splitting on [,] of the values into TinCanJS
      if (objDef.interactionType === "matching") {
        if (objDef.source && objDef.source.length > 0 && objDef.target && objDef.target.length > 0) {
          source = objDef.source;
          target = objDef.target;
          responses = response.split("[,]");
          for (i = 0; i < responses.length; i += 1) {
            responseParts = responses[i].split("[.]");
            for (j = 0; j < source.length; j += 1) {
              if (responseParts[0] === source[j].id) {
                if (!first) {
                  responseStr.push(", ");
                }
                responseStr.push(svc.getComponentDisplay(source[j]));
                first = false;
              }
            }
            for (j = 0; j < target.length; j += 1) {
              if (responseParts[1] === target[j].id) {
                responseStr.push(" -> ");
                responseStr.push(svc.getComponentDisplay(target[j]));
              }
            }
          }
        }
      } else {
        if (objDef.interactionType === "choice" || objDef.interactionType === "sequencing") {
          componentName = "choices";
        } else if (objDef.interactionType === "likert") {
          componentName = "scale";
        } else if (objDef.interactionType === "performance") {
          componentName = "steps";
        }
        if (componentName) {
          components = objDef[componentName];
          if (components && components.length > 0) {
            responses = response.split("[,]");
            for (i = 0; i < responses.length; i += 1) {
              for (j = 0; j < components.length; j += 1) {
                responseId = responses[i];
                if (objDef.interactionType === "performance") {
                  responseId = responses[i].split("[.]")[0];
                }
                if (responseId === components[j].id) {
                  if (!first) {
                    responseStr.push(", ");
                  }
                  responseStr.push(svc.getComponentDisplay(components[j]));
                  if (objDef.interactionType === "performance") {
                    responseStr.push(" -> ");
                    responseStr.push(responses[i].split("[.]")[1]);
                  }
                  first = false;
                }
              }
            }
          }
        }
      }
      if (responseStr.length > 0) {
        return $sanitize(responseStr.join(""));
      }
      return $sanitize(response);
    }
    var adlVerbMap = {
      "http://adlnet.gov/expapi/verbs/experienced": "experienced",
      "http://adlnet.gov/expapi/verbs/attended": "attended",
      "http://adlnet.gov/expapi/verbs/attempted": "attempted",
      "http://adlnet.gov/expapi/verbs/completed": "completed",
      "http://adlnet.gov/expapi/verbs/passed": "passed",
      "http://adlnet.gov/expapi/verbs/failed": "failed",
      "http://adlnet.gov/expapi/verbs/answered": "answered",
      "http://adlnet.gov/expapi/verbs/interacted": "interacted",
      "http://adlnet.gov/expapi/verbs/imported": "imported",
      "http://adlnet.gov/expapi/verbs/created": "created",
      "http://adlnet.gov/expapi/verbs/shared": "shared",
      "http://adlnet.gov/expapi/verbs/voided": "voided"
    };
    _.extend(adlVerbMap, _.object(_.map(adlVerbMap, function (value, key) {
      return [key + '/', value];
    })));
    var svc = {
      tincan: null,
      get: function get() {
        if (!this.tincan) {
          var endpoint = Utils.qualifyURL(Api.url("/lrs/"));
          this.tincan = new TinCan({
            url: window.location.href,
            recordStores: [new TinCan.LRS({
              endpoint: endpoint,
              version: "1.0.0",
              auth: "Cookie wsAuth"
            })]
          });
          this.tincan.actor = this.getCurrentAgent();
        }
        return this.tincan;
      },
      reload: function reload() {
        this.tincan = null;
        return this.get();
      },
      sendStatement: function sendStatement(statement) {
        var self = this,
          future = $q.defer();

        // Send the statement
        self.get().sendStatement(statement,
        // The call back
        function then(results) {
          var hasError = _.any(results, function (result) {
            return result.err;
          });
          if (hasError) {
            future.reject(results);
          } else {
            future.resolve(results);
          }
        },
        // The config to send with the request
        {
          headers: xsrf.getHeaders()
        });
        return future.promise;
      },
      getUserPersona: function getUserPersona(user) {
        user = user || User.get().user;
        var persona = {
          "name": user.name,
          "mbox": "mailto:" + user.email
        };
        if (user.username && user.username.indexOf('|') >= 0) {
          var userNameParts = user.username.split('|');
          persona = {
            "name": user.name,
            "account": {
              "homePage": userNameParts[0],
              "name": userNameParts[1]
            }
          };
        }
        return persona;
      },
      getCurrentAgent: function getCurrentAgent() {
        return new TinCan.Agent(this.getUserPersona());
      },
      _getActorBaseName: function _getActorBaseName(actor) {
        //Scorm Cloud sends UNKNOWN NAME sometimes, we don't want to show that
        if (actor.name && actor.name !== wsConstants.unknownActorName) {
          return actor.name;
        } else if (actor.mbox) {
          return actor.mbox.replace('mailto:', '');
        } else if (actor.account) {
          return actor.account.name;
        } else if (actor.openid) {
          return actor.openid;
        } else {
          return '--';
        }
      },
      getActorName: function getActorName(actor) {
        // if Actor is a Group that has Members...
        if (actor.member && actor.member.length > 0) {
          var groupName = this._getActorBaseName(actor),
            groupMembers = this._getActorBaseName(actor.member[0]) + " and " + (actor.member.length - 1).toString() + " others";
          if (groupName) {
            groupMembers = groupName + " (" + groupMembers + ")";
          }
          return $sanitize(groupMembers);
        } else {
          return $sanitize(this._getActorBaseName(actor));
        }
      },
      getVerbName: function getVerbName(verb, inProgress) {
        var verbName;
        if (!_.isEmpty(verb.display)) {
          verbName = this.getLanguageMapDisplay(verb.display);
        } else if (adlVerbMap[verb.id]) {
          verbName = adlVerbMap[verb.id];
        } else {
          var verbIdParts = verb.id.split("/");
          verbName = verbIdParts[verbIdParts.length - 1];
        }
        if (verbName === "interacted") {
          verbName = "interacted with";
        } else if (inProgress === true) {
          verbName = verbName + " (in progress)";
        }
        return $sanitize(verbName);
      },
      getComponentDisplay: function getComponentDisplay(targetObject) {
        if (targetObject.description) {
          return this.getLanguageMapDisplay(targetObject.description);
        }
        return $sanitize(targetObject.id);
      },
      getActivityDisplay: function getActivityDisplay(targetObject) {
        if (targetObject.definition) {
          if (targetObject.definition.name) {
            return this.getLanguageMapDisplay(targetObject.definition.name);
          }
          if (targetObject.definition.description) {
            return this.getLanguageMapDisplay(targetObject.definition.description);
          }
        }
        return $sanitize(targetObject.id);
      },
      getActivityTypeDisplay: function getActivityTypeDisplay(activityTypeUri) {
        if (!activityTypeUri) {
          return activityTypeUri;
        }
        //split on '/'
        var parts = activityTypeUri.split('/').reverse();

        //we loop through the revered array and will return the last non empty word
        for (var i = 0; i < parts.length; i++) {
          if (parts[i]) {
            return parts[i];
          }
        }
        //return the entire URI if we fail
        return activityTypeUri;
      },
      getLanguageMapDisplay: function getLanguageMapDisplay(obj) {
        var result = '';
        if (obj) {
          if (obj['en-US']) {
            result = obj['en-US'];
          } else if (obj['EN-US']) {
            result = obj['EN-US'];
          } else if (obj['en-us']) {
            result = obj['en-us'];
          } else if (obj.und) {
            result = obj.und;
          } else {
            //Everything else failed, see if we can grab first element
            for (var key in obj) {
              if (obj[key]) {
                result = obj[key];
              }
            }
          }
        }
        return $sanitize(result);
      },
      isActorGroup: function isActorGroup(actor) {
        //for statements from TinCanJS
        if (actor instanceof TinCan.Group) {
          return true;
        }
        //for statements from ES
        if (actor.objectType && actor.objectType === 'Group') {
          return true;
        }
        return false;
      },
      getAdverb: function getAdverb(verb, targetObject, result) {
        if (targetObject && targetObject.definition && targetObject.definition.type) {
          var activityType = targetObject.definition.type;
          if (activityType === "question" || activityType.indexOf("interaction") >= 0) {
            if (verb && verb.id && verb.id.indexOf("http://adlnet.gov/expapi/verbs/answered") === 0) {
              if (result && result.success !== null && result.success !== undefined) {
                return result.success ? "correctly " : "incorrectly ";
              }
            }
          }
        }
        return '';
      },
      // The serialized Statement objects we get back in some instances, like csv import preview, contain
      // serialized Rustici objects that have a Value member.
      getValue: function getValue(o) {
        if (o && _.has(o, "Value")) {
          return o.Value;
        } else {
          return o;
        }
      },
      getScore: function getScore(result) {
        if (result && result.score) {
          if (!_.isUndefined(result.score.scaled)) {
            return Math.round(this.getValue(result.score.scaled) * 100.0) + "%";
          } else if (this.getValue(result.score.raw)) {
            return this.getValue(result.score.raw);
          }
        }
        return '';
      },
      getResponse: function getResponse(targetObject, result) {
        if (targetObject && targetObject.definition) {
          var activityType = targetObject.definition.type;
          if (targetObject.definition.interactionType || activityType === "question" || activityType && activityType.indexOf("interaction") >= 0) {
            if (result && result.response) {
              var response = getResponseText(targetObject, result);
              // strip urn:scormdriver: response prefix & uri encoding - MUST be done before truncate
              // because '...' in tructated string causes decodeURI to fail
              response = response.replace(/urn:scormdriver:/g, '');
              try {
                response = decodeURIComponent(response);
              } catch (err) {}
              return $sanitize(truncateString(response, 100));
            }
          }
        }
      },
      getDecoratedStatements: function getDecoratedStatements(statements) {
        var self = this;
        return _.map(statements, function (stmt) {
          var object = stmt.object ? stmt.object : stmt.target;
          return _.extend(stmt, {
            actorName: self.getActorName(stmt.actor),
            isActorGroup: self.isActorGroup(stmt.actor),
            verbName: self.getVerbName(stmt.verb, stmt.inProgress),
            //object is populated by ES, target is populated by TinCanJS
            objectName: object.objectType === "Agent" ? self.getActorName(object) : self.getActivityDisplay(object)
          });
        });
      },
      getExtendedDecoratedStatements: function getExtendedDecoratedStatements(statements) {
        var decoratedStatements = this.getDecoratedStatements(statements);
        var self = this;
        return _.map(decoratedStatements, function (stmt) {
          var targetObject = stmt.object ? stmt.object : stmt.target;
          return _.extend(stmt, {
            adverb: self.getAdverb(stmt.verb, targetObject, stmt.result),
            response: self.getResponse(targetObject, stmt.result),
            score: self.getScore(stmt.result)
          });
        });
      }
    };
    return svc;
  }]).
  /**
   * A service that provides access to the TinCan Activity Profile API.
   */
  factory("ActivityProfile", ['$q', 'TinCanJS', function ($q, TinCanJS) {
    var tincan = TinCanJS.get();
    return {
      get: function get(profileID, activityID, options) {
        var defer = $q.defer();
        options = options || {};
        options.activity = activityID ? {
          id: activityID
        } : options.activity;
        tincan.getActivityProfile(profileID, angular.extend(options, {
          callback: function callback(err, result) {
            if (!err && result) {
              defer.resolve(JSON.parse(result.contents), result.etag);
            } else {
              defer.reject(err);
            }
          }
        }));
        return defer.promise;
      },
      set: function set(profileID, value, activityID, options) {
        var defer = $q.defer();
        options = options || {};
        options.activity = activityID ? {
          id: activityID
        } : options.activity;
        tincan.setActivityProfile(profileID, JSON.stringify(value), angular.extend(options, {
          callback: function callback(err, result) {
            if (!err && result) {
              defer.resolve();
            } else {
              defer.reject(err);
            }
          }
        }));
        return defer.promise;
      },
      clear: function clear(profileID, activityID, options) {
        var defer = $q.defer();
        options = options || {};
        options.activity = activityID ? {
          id: activityID
        } : options.activity;
        tincan.deleteActivityProfile(profileID, angular.extend(options, {
          callback: function callback(err, result) {
            if (!err && result) {
              defer.resolve();
            } else {
              defer.reject(err);
            }
          }
        }));
        return defer.promise;
      }
    };
  }]).
  /**
   * A service that provides access to the TinCan Activity Profile API.
   */
  factory("State", ['$q', 'TinCanJS', function ($q, TinCanJS) {
    var tincan = TinCanJS.get();
    return {
      get: function get(stateID, activityID, agent, registration, options) {
        var defer = $q.defer();
        options = options || {};
        options.activity = activityID ? {
          id: activityID
        } : options.activity;
        options.agent = agent || options.agent;
        options.registration = registration || options.registration;
        tincan.getState(stateID, angular.extend(options, {
          callback: function callback(err, result) {
            if (!err && result) {
              defer.resolve(JSON.parse(result.contents), result.etag);
            } else {
              defer.reject(err);
            }
          }
        }));
        return defer.promise;
      },
      set: function set(stateID, value, activityID, agent, registration, options) {
        var defer = $q.defer();
        options = options || {};
        options.activity = activityID ? {
          id: activityID
        } : options.activity;
        options.agent = agent || options.agent;
        options.registration = registration || options.registration;
        tincan.setState(stateID, JSON.stringify(value), angular.extend(options, {
          callback: function callback(err, result) {
            if (!err && result) {
              defer.resolve();
            } else {
              defer.reject(err);
            }
          }
        }));
        return defer.promise;
      },
      clear: function clear(stateID, activityID, agent, registration, options) {
        var defer = $q.defer();
        options = options || {};
        options.activity = activityID ? {
          id: activityID
        } : options.activity;
        options.agent = agent || options.agent;
        options.registration = registration || options.registration;
        tincan.deleteState(stateID, angular.extend(options, {
          callback: function callback(err, result) {
            if (!err && result) {
              defer.resolve();
            } else {
              defer.reject(err);
            }
          }
        }));
        return defer.promise;
      }
    };
  }]);
})();
